import React from 'react';
import { Content, DetailContent, PlanContent, Subtitle } from './styles';
import { BsFillTagFill } from 'react-icons/bs';
import { BiCalendar } from 'react-icons/bi';
import formatPrice from '../../services/utils/formatPrice';

type Props = {
  negotiationInfo: GQL.IOption[];
};

const NegotiatioInfoCard = ({ negotiationInfo }: Props) => {
  const formatType = (type: string) => {
    if (type === 'Quitacao') return 'Quitação';
    else if (type === 'Renegociacao') return 'Renegociação';
    else {
      return 'Atualização';
    }
  };

  return (
    <Content>
      <PlanContent className='mobile-1'>
        <span>{negotiationInfo?.[0]?.plan}x</span>
      </PlanContent>
      <DetailContent className='mobile-2'>
        <div className='contentText'>
          <span className={'spanContent'}>À Vista</span>
          <Subtitle>
            R${' '}
            {negotiationInfo?.[0]?.totalValue &&
              formatPrice(negotiationInfo[0].totalValue)}
          </Subtitle>
          <div className='contentInfo'>
            <div style={{ display: 'flex' }}>
              <BsFillTagFill className='space-right' />
              <span>Tipo:</span>{' '}
              <strong className='space-left'>
                {' '}
                {formatType(
                  negotiationInfo?.[0]?.negotiationTypeDescription || ''
                )}
              </strong>
              <span className='space-right space-left'> | </span>
            </div>
            <div style={{ display: 'flex' }}>
              <BiCalendar className='space-right' />
              <span>Vencimento:</span>{' '}
              <strong className='space-left'>
                {negotiationInfo?.[0]?.formatedDueDate}
              </strong>
            </div>
          </div>
        </div>
      </DetailContent>
    </Content>
  );
};

export default NegotiatioInfoCard;
